import { deleteEntry, bulkDeleteEntries, getContentType, getEntries, createEntry, getEntry, updateEntry, updatePreviewEntry, translateEntry, getEntryVersionsList, duplicateEntry, scheduleEntry } from '../api/api';

export const UPDATE_STEP_DATA = 'UPDATE_STEP_DATA';
export const RESET_FORM = 'RESET_FORM';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const ADD_FIELD = 'ADD_FIELD';

export const addField = (fieldData) => ({
  type: ADD_FIELD,
  payload: fieldData,
});
export const UPDATE_CONTENT_TYPE = 'UPDATE_CONTENT_TYPE';

export const updateField = (index, fieldData) => ({
  type: UPDATE_FIELD,
  payload: { index, fieldData }
});

export const updateContentType = (contentTypeData) => ({
  type: UPDATE_CONTENT_TYPE,
  payload: contentTypeData,
});

export const resetForm = () => ({
  type: RESET_FORM,
});


export const getAllEntries = (workspaceId, params = {}) => async (dispatch) => {
  try {
    const res = await getEntries(workspaceId, params);
    dispatch({
      type: 'GET_ALL_ENTRIES',
      payload: res.data
    });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}


export const getContentTypeForEntry = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getContentType(workspaceId, id);
    dispatch({
      type: 'GET_CONTENT_TYPE_FOR_ENTRY',
      payload: res.data
    });

  } catch (err) {
    console.log(err)
  }
}



export const submitFormData = (entryData) => async (dispatch) => {
  try {
    dispatch({
      type: 'FORM_SUBMISSION_REQUEST'
    });
    const res = await createEntry(entryData);
    dispatch({
      type: 'FORM_SUBMISSION_SUCCESS',
      payload: res.data
    });
    return res.data;

  } catch (error) {
    dispatch({
      type: 'FORM_SUBMISSION_FAILURE',
      payload: error.message
    });
    return error.response.data;
  }

}

export const getEntryForEdit = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getEntry(workspaceId, id);
    dispatch({
      type: 'GET_SINGLE_ENTRY',
      payload: res.data
    });

  } catch (err) {
    console.log(err)
  }
}

export const getEntryForDrawer = (workspaceId, entryId) => async (dispatch) => {
  try {
    const res = await getEntry(workspaceId, entryId);

    dispatch({
      type: 'GET_ENTRY_FOR_DRAWER',
      payload: res.data
    });

  } catch (error) {
    console.error('Error fetching drawer entry:', error);
  }
};

export const updateEntryData = (id, data) => async (dispatch) => {
  try {
    const res = await updateEntry(id, data);
    return res.data;
  } catch (error) {

    console.error('Failed to submit form:', error);
    return error.response.data;
  }
}

export const scheduleEntryData = (workspaceId, id, data) => async (dispatch) => {
  try {
    const res = await scheduleEntry(workspaceId, id, data);
    return res.data;
  } catch (error) {
    console.error('Failed to update entry schedule:', error);
    return error.response.data;
  }
}

export const updatePreviewEntryData = (id, data) => async (dispatch) => {
  try {
    const res = await updatePreviewEntry(id, data);
    return res.data;
  } catch (error) {

    console.error('Failed to submit form:', error);
    return error.response.data;
  }
}



export const removeEntry = (id) => async (dispatch) => {
  try {
    const res = await deleteEntry(id);
    if (res.status === 200) {
      dispatch({
        type: 'DELETE_ENTRY',
        payload: id
      })
    }

  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const bulkRemoveEntries = (ids) => async (dispatch) => {
  try {
    const res = await bulkDeleteEntries(ids);
    if (res.status === 200) {
      (res.data?.deleted || []).forEach((id) => {
        dispatch({
          type: 'DELETE_ENTRY',
          payload: id
        })
      });
    }
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const translateEntryAction = (workspaceId, id, locale) => async (dispatch) => {
  try {
    const res = await translateEntry(workspaceId, id, locale);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const getEntryVersions = (workspaceId, entryId) => async (dispatch) => {
  try {
    const res = await getEntryVersionsList(workspaceId, entryId);
    dispatch({
      type: 'GET_ENTRY_VERSIONS',
      payload: res.data
    });
  } catch (error) {
    console.error('Error fetching version history:', error);
  }
};
export const duplicateEntryAction = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await duplicateEntry(workspaceId, id);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
